import { Button, H2 } from "@sellar-io/components";
import { ReactElement, useEffect } from "react";
import { useIntercom } from "react-use-intercom";
import { useShallow } from "zustand/react/shallow";
import type { RetailerListElementResponseType } from "@sellar-io/api-v2/types";
import { useEvents } from "../../../../../../hooks";

import {
  BuyerCreationFlowStep,
  useBuyerCreationFlowStore,
} from "../BuyerCreationFlowStore";

export function BuyerSignupBusinessClaimedContent({
  buyer,
  setBuyerDetails,
}: {
  setBuyerDetails: (buyer: RetailerListElementResponseType | undefined) => void;
  buyer: RetailerListElementResponseType;
}): ReactElement {
  const intercom = useIntercom();
  const { setStep } = useBuyerCreationFlowStore(
    useShallow((state) => ({
      setStep: state.setStep,
    })),
  );
  const { track } = useEvents();
  useEffect(() => {
    track("Venue Not Claimed");
  }, [track]);
  return (
    <div className={"m-auto flex flex-col justify-center gap-4"}>
      <div className={"flex flex-col gap-2"}>
        <H2 className={"text-center"}>Venue already claimed</H2>
        <p className={"text-center"}>
          The business account for <strong>{buyer.Business.name}</strong> is
          already setup by another member of your team.
        </p>
        <p className={"text-center"}>
          You can ask them to add you to the account. Alternatively contact the
          Sellar team to request access.
        </p>
      </div>
      <div className="grid gap-2 md:grid-cols-2">
        <Button
          className={"col-span-2 w-full md:col-span-1"}
          onClick={() => {
            setStep(BuyerCreationFlowStep.BuyerBusinessMatchStep);
            setBuyerDetails(undefined);
          }}
          color={"secondary"}
        >
          Go back
        </Button>
        <Button
          className={"col-span-2 w-full md:col-span-1"}
          onClick={() => intercom.show()}
        >
          Get in touch
        </Button>
      </div>
    </div>
  );
}
